// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal___3rBB1","modelContent":"modelContent___2sXKU","title2":"title2___nYy3p","btn":"btn___6PWIW"};